// @create by YongYel.Kim / devp019
import {getTreeData, jsonToFromData} from '~/utils/admin-common'
import {deviceDataTreeConvert} from '~/utils/device-common'
import {code} from '~/static/code.json'
import { SystemApiPrefix as apiPrefix } from '~/utils/restApi'

const ApiUrl = {
  testUrl: '',
  url: '/api/sm/managers', // 관리자 설정
  devicesUrl: '/api/sm/devices', // 장비 설정
  devicesTreeUrl: '/api/sm/devices-tree', // 장치관리 리스트
  managersDeviceParentUrl: '/api/sm/managers-device-parent', // 관리자별 장비권한 변경 상위 포함
  managersDeviceUrl: '/api/sm/managers-device', // 장비 정보
  managersIpUrl: '/api/sm/managers-ip', // 관리자 아이피
  managersIpAllUrl: '/api/sm/managers-ip/all', // 관리자 아이피 전체
  managersIpSecUrl: '/api/sm/managers-ip/sec', // 사용중인 아이피
  managersIpAddUrl: '/api/sm/managers-ip/add', // 아이피 추가
  managersIpDelUrl: '/api/sm/managers-ip/del', // 아이피 삭제
  managersIpNewUrl: '/api/sm/managers-ip/new', // 관리자 아이피 추가
  managersSecurityUrl: '/api/sm/managers/security', // 단일 관리자 계정 보안설정
  managersMenuUrl: '/api/sm/managers-menu', // 메뉴 리스트(트리)
  managersGroupUrl: '/api/sm/managers', // 관리자/그룹 기본정보 추가
  managersDetailUrl: '/api/sm/managers-detail', // 관리자 상세 정부
  managersImgUrl: '/api/sm/managers/img', // 관리자 이미지
  generalSettUrl: '/api/sm/admin/general', // 공통설정 가져오기
  managersPwdUrl: '/api/sm/managers/pwd', // 관리자 비밀번호 변경
  cidrToIplistUrl: '/api/sm/cidrtoiplist', // 아이피 cidr
  managersAllUrl: '/api/sm/managers-all', // 관리자 그룹 전체
  managersIpInhritUrl: '/api/sm/managers-ip/inhrit',
  externalAuthUrl: '/api/sm/managers/extern-auth' // 외부 연동
}

const initAdminDetail = () => {
  return {
    admin_email: '',
    admin_depart_name: '',
    admin_phone: '',
    admin_desc: '',

    admin_last_login_dt: void 0,
    admin_locale_type: '1',
    admin_lock_limit_dt: void 0,
    admin_login_pw: void 0,
    admin_login_uname: '',

    admin_pw_expire_date: void 0,
    admin_pw_expire_term: void 0,
    admin_unuse_expire_dt: void 0,
    admin_valid_end_date: void 0,
    admin_valid_start_date: void 0,
    detail_cnt: void 0,
    img_cnt: void 0,
    // TAMS
    admin_otp_enable_yn: 0,
    admin_otp_key: '',
    admin_otp_type: 1,

    // external auth
    extern_auth_allow_ver: 4,
    extern_auth_allow_ip: void 0,
    extern_auth_key: void 0,
    extern_auth_referer_use_yn: void 0,
    extern_auth_uagnt_use_yn: void 0,
    extern_auth_uagnt_val: void 0,
    extern_auth_use_yn: void 0
  }
}
const getDefaultState = () => {
  return {
    code: code,
    // 공통설정값
    generalConfig: {},
    // submit data
    // 관리자 상세정보값
    adminGeneral: {},
    adminImageUrl: null,
    adminDetail: initAdminDetail(),
    adminDeviceCur: [],
    adminMenuCurr: [],
    adminIpCurr: [],
    adminOtpMenu: [],

    // 관리자 아이피
    adminIpSel: [],
    // 등록된 전체 아이피
    adminIpAll: [],
    // 상위 아이피 정보
    adminIpParent: [],
    adminIpRange: {
      strart_ip: '',
      end_ip: '',
      ip_exp: '',
      ip_desc: ''
    },
    adminPopupIp: {
      start_ip: '',
      end_ip: '',
      ip_exp: '',
      ip_desc: ''
    },
    // 사용중인IP 관리그룹
    yourIpGroup: [],
    // 관리자 장비 그룹
    adminDeviceSel: [],
    adminDeviceParent: [],
    adminDeviceTree: [],
    adminDeviceExpanded: [],
    // 관리자 메뉴
    admin_menu_inhrit_yn: 1,
    adminMenuParent: [],
    oldAdminMenuParent: [],
    adminMenuTree: [],
    adminMenuExpanded: [],

    // 관리자 추가/편집/삭제 결과
    addPostResult: null,
    postManagerIpResult: null,
    postManagerDeviceResult: null,
    postManagerMenuResult: null,
    postManagerDetailResult: null,
    // 관리자/그룹이동
    putManagersResult: null,
    postManagersSecurityResult: null,
    postManagersPwdResult: null,
    postManagersDeviceParent: null,
    putManagersLocaleResult: null,
    // ip관리자별 관리자 아이피
    PostManagersIpNewResult: null,
    DelManagersIpSecResult: null,
    // 에러 발생시
    errorMessage: ''
  }
}

export const state = () => getDefaultState()

export const mutations = {
  releaseAllState (state) {
    // Object.assign(state, getDefaultState())
    const defaultState = getDefaultState()
    _.forEach(defaultState, (v, k) => {
      state[k] = v
    })
  },

  mutaionAdminIpCurrConcat (stat, data) {
    data.forEach(item => {
      stat.adminIpCurr.push(item)
    })
  },
  mutationGetManagersImg (state, data) {
    if (_.isObject(data)) {
      state.adminImageUrl = ''
    }
  },
  // 관리자별 관리장비 그룹편집
  postManagersDeviceParent (state, data) {
    state.postManagersDeviceParent = data
  },
  // 장치 리스트 가져오기
  mutDeviceTree (state, data) {
    state.adminDeviceParent = JSON.parse(JSON.stringify(data.data))
    // state.adminDeviceTree = data.result
    if (data.isParent === undefined || (data.isParent !== undefined && !data.isParent)) {
      state.adminDeviceTree = []
      if (data.data.length > 0) {
        const _tempData = data.data.filter((item) => {
          item.disabled = false
          item['removed'] = false
          if (typeof data.isGroup !== 'undefined' && data.isGroup && item.device_type !== 0) {
            item.removed = true
          }
          if (typeof data.isGroupDisabled !== 'undefined' && data.isGroupDisabled && item.device_type === 0) {
            item.disabled = true
          }
          return item.removed === false
        })

        state.adminDeviceTree = deviceDataTreeConvert(_tempData, _tempData[0].device_id)
        state.adminDeviceExpanded = _tempData.map(item => {
          return item.device_id
        })
      }
    }
  },
  // 등록된 전체 아이피
  mutManagersIpAll (state, data) {
    state.adminIpAll = data.result
  },
  acsManagersIp (state, data) {
    state.adminIpParent = data.result
  },
  // 사용중인 ip admingroupadmingroup
  mutYourIpGroup (state, data) {
    state.yourIpGroup = data.map((item) => {
      return item.admin_id
    })
  },
  mutPostManagersIpNewResult (state, data) {
    state.PostManagersIpNewResult = data
  },
  mutDelManagersIpSecResult (state, data) {
    state.DelManagersIpSecResult = data
  },
  acsManagersGroup (state, payload) {
    state.adminGeneral = {
      admin_device_inhrit_yn: payload.admin_device_inhrit_yn.toString(),
      admin_id: payload.admin_id,
      admin_ip_inhrit_yn: payload.admin_ip_inhrit_yn.toString(),
      admin_menu_inhrit_yn: payload.admin_menu_inhrit_yn.toString(),
      admin_name: payload.admin_name,
      admin_type: payload.admin_type,
      parent_admin_id: payload.parent_admin_id,
      parent_admin_name: payload.parent_admin_name
    }

    let externIpVersion = 4
    if (typeof payload.extern_auth_allow_ip === 'string') {
      externIpVersion = payload.extern_auth_allow_ip.indexOf('.') > -1 ? 4 : 6
    }
    state.adminDetail = {
      admin_depart_name: payload.admin_depart_name,
      admin_desc: payload.admin_desc,
      admin_email: payload.admin_email,
      admin_last_login_dt: payload.admin_last_login_dt,
      admin_locale_type: (payload.admin_locale_type === null) ? '1' : payload.admin_locale_type.toString(),
      admin_lock_limit_dt: payload.admin_lock_limit_dt,
      admin_login_pw: payload.admin_login_pw,
      admin_login_uname: payload.admin_login_uname,
      admin_phone: payload.admin_phone,
      admin_pw_expire_date: payload.admin_pw_expire_date,
      admin_pw_expire_term: payload.admin_pw_expire_term,
      admin_unuse_expire_dt: payload.admin_unuse_expire_dt,
      admin_valid_end_date: payload.admin_valid_end_date,
      admin_valid_start_date: payload.admin_valid_start_date,
      detail_cnt: payload.detail_cnt,
      img_cnt: payload.img_cnt,
      // TAMS
      admin_otp_enable_yn: payload.admin_otp_enable_yn,
      admin_otp_key: payload.admin_otp_key || '',
      admin_otp_type: payload.admin_otp_type,

      // external auth
      extern_auth_allow_ver: externIpVersion,
      extern_auth_allow_ip: payload.extern_auth_allow_ip,
      extern_auth_key: payload.extern_auth_key,
      extern_auth_referer_use_yn: payload.extern_auth_referer_use_yn,
      extern_auth_uagnt_use_yn: payload.extern_auth_uagnt_use_yn,
      extern_auth_uagnt_val: payload.extern_auth_uagnt_val,
      extern_auth_use_yn: payload.extern_auth_use_yn
    }

    state.adminImageUrl = `${ApiUrl.managersImgUrl}/${state.adminGeneral.admin_id}?${Date.now()}`
    if (this.getters['common/authenticate/isExistGeToken']) {
      const url = state.adminImageUrl
      const geToken = _.get(this, ['state', 'common', 'authenticate', 'geToken'])
      state.adminImageUrl = `/GE:${geToken}${url}`
    }
    state.adminDeviceCur = payload.admin_device
    state.adminMenuCurr = payload.admin_menu
    state.adminIpCurr = payload.admin_ip
  },
  // 관리자 그룹 추가, 삭제
  mutPostMmanagersgroup (state, payload) {
    state.addPostResult = payload
  },
  // 트리
  mutationMenuTree (state, data) {
    state.oldAdminMenuParent = JSON.parse(JSON.stringify(data.result))
    state.adminMenuParent = data.result
    state.adminMenuTree = []

    if (data.result.length > 0) {
      state.adminMenuTree = getTreeData(data.result,
        {
          id: 'menu_id',
          parent: 'parent_menu_id',
          label: 'menu_name',
          level: 'lv'
        }
      )
      state.adminMenuExpanded = data.result.map((item) => {
        return item.menu_id
      })
    }
  },
  acsCidrToIplist (state, payload) {
    state.adminIpRange.strart_ip = payload.start_ip
    state.adminIpRange.end_ip = payload.end_ip
  },
  // 공통설정, (2021-07-28) 현재 사용안하는 것으로 보임
  acsGetAdminGeneral (state, payload) {
    state.adminDetail.admin_valid_term = payload.admin_valid_term
    const curDt = new Date()
    const endDt = new Date(curDt.getFullYear(), curDt.getMonth(), curDt.getDate() + parseInt(payload.admin_valid_term))
    state.adminDetail.admin_valid_start_date = curDt
    state.adminDetail.admin_valid_end_date = endDt
    state.adminDetail.admin_pw_expire_term = payload.admin_pw_expire_term
  },
  // SUBMIT
  mutationPostManagerIp (state, payload) {
    state.postManagerIpResult = payload
  },
  // 장치 추가 상태
  postManagerDeviceResult (state, payload) {
    state.postManagerDeviceResult = payload
  },
  // 메뉴 추가 상태
  postManagerMenuResult (state, payload) {
    state.postManagerMenuResult = payload
  },
  // 관리자/그룹이동
  mutationPutManagers (state, payload) {
    state.putManagersResult = payload
  },
  mutationPutManagersLocale (state, payload) {
    state.putManagersLocaleResult = payload
  },
  // 기본상세 등록 상태
  mutationManagerDetailResult (state, payload) {
    state.postManagerDetailResult = payload
  },
  // 관리자 계정 보안설정
  mutationPostmanagersSecurityResult (state, payload) {
    state.postManagersSecurityResult = payload
  },
  mutationPostManagersPwd (state, payload) {
    state.postManagersPwdResult = payload
  },
  mutationErrorMessage (state, payload) {
    state.errorMessage = payload
  },
  updateExternalAuthKey (state, payload) {
    state.adminDetail.extern_auth_key = payload
  },
  setAdminOtpMenu (state, payload) {
    state.adminOtpMenu = payload
  }
}
export const actions = {
  // 전체 장비 가져오기 / parent 값
  acsAllDevice ({commit, state}, payload) {
    const result = {}
    result.error = null
    if (payload.yn === undefined) {
      payload.yn = 0
    }
    let url = `${ApiUrl.devicesTreeUrl}?admin_id=${payload.id}&only_group_yn=${payload.yn}`
    if (payload.isParent) {
      url = `${ApiUrl.managersDeviceUrl}?admin_id=${payload.id}&only_group_yn=${payload.yn}`
    }
    this.$axios.$get(url)
      .then((res) => {
        if (payload.isParent === undefined) {
          result.data = res.result
          result.isGroup = payload.isGroup
          if (typeof payload.isGroupDisabled !== 'undefined') {
            result.isGroupDisabled = payload.isGroupDisabled
          }
        } else {
          result.data = res.result
          result.isGroup = payload.isGroup
          if (typeof payload.isGroupDisabled !== 'undefined') {
            result.isGroupDisabled = payload.isGroupDisabled
          }
        }
        result.isParent = payload.isParent
        commit('mutDeviceTree', result)
      })
      .catch((error) => {
        result.error = error
      })
  },
  // PAMS > 대상 방화벽 설정 추가 가능 장비 가져오기 / parent 값
  async firewallAddDevice ({commit}) {
    const result = {}
    result.error = null
    const url = '/api/pm/use-firewall/device'
    try {
      const data = await this.$axios.$get(url)
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      result.data = data.result
      commit('mutDeviceTree', result)
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async acsPostManagersDeviceParent ({commit, state}, payload) {
    try {
      const data = await this.$axios.$post(`${ApiUrl.managersDeviceParentUrl}/${payload.admin_id}`, payload.device, {loading: false, successAlert: false})
      if (data.code.toUpperCase() !== 'OK') {
        return {code: 'nok', errors: data.result.msg}
      }
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 장치(그룹) 관리 가져오기
  acsDeviceTree ({commit, state}, adminId) {
    const result = {}
    result.error = null
    this.$axios.$get(`${ApiUrl.managersDeviceUrl}?admin_id=${adminId}&only_group_yn=1`)
      .then((res) => {
        result.data = res.result
        result.adminId = adminId
        commit('mutDeviceTree', result)
      })
      .catch((error) => {
        commit('mutationErrorMessage', error)
      })
  },
  /**
   * 장치정보 등록
   * - payload.admin_device_inhrit_yn: "1"  <1:상속,0:개별>
   * - payload.admin_device: [1,2,7]
  **/
  async acsPostManagersDevice ({commit, state}, payload) {
    try {
      const data = await this.$axios.$post(`${ApiUrl.managersDeviceUrl}/${payload.admin_id}`, payload.device, {loading: false, successAlert: false})
      if (data.code.toUpperCase() !== 'OK') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('postManagerDeviceResult', data.result)
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 동록된 전체 아이피 정보 가져오기
  acsManagersIpAll ({commit}) {
    const adminId = 1
    const result = {}
    result.error = null
    result.adminId = adminId
    this.$axios.$get(`${ApiUrl.managersIpAllUrl}`)
      .then((res) => {
        result.result = res.result
        commit('mutManagersIpAll', result)
      })
      .catch((error) => {
        result.error = error
        // commit('acsManagersIp', result)
      })
  },
  // 상위그룹 아이피 정보 가져오기
  acsManagersIp ({commit, state}, adminId) {
    const result = {}
    result.error = null
    result.adminId = adminId
    this.$axios.$get(`${ApiUrl.managersIpUrl}/${adminId}`)
      .then((res) => {
        result.result = res.result
        commit('acsManagersIp', result)
      })
      .catch((error) => {
        result.error = error
        commit('acsManagersIp', result)
      })
  },
  async acsPostManagerIp ({commit, state}, payload) {
    try {
      const data = await this.$axios.$post(`${ApiUrl.managersIpUrl}/${payload.admin_id}`, payload.ip)
      if (data.code !== 'ok') {
        commit('mutationErrorMessage', data.result.msg)
        return false
      }
      commit('mutationPostManagerIp', data)
      return 'ok'
    } catch (error) {
      commit('mutationErrorMessage', error)
      return error
    }
  },
  acsPostManagersIpNew ({commit, state}, payload) {
    this.$axios.$post(`${ApiUrl.managersIpNewUrl}`, payload)
      .then((res) => {
        if (res.code === 'ok') {
          commit('mutPostManagersIpNewResult', res)
        } else {
          commit('mutationErrorMessage', res.result.msg)
        }
      })
      .catch((err) => {
        commit('mutationErrorMessage', err)
      })
  },
  // 아이피 사용중인 관리그룹
  async acsManagersIpSec ({commit, state}, payload) {
    try {
      const data = await this.$axios.$get(`${ApiUrl.managersIpSecUrl}?ip=${payload.ip}`, {loading: false, successAlert: false})
      if (data.code !== 'ok') {
        commit('mutYourIpGroup', [])
        return {code: 'nok', errors: data.result.msg}
      }
      commit('mutYourIpGroup', data.result)
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 관리자병 아이피설정 - ip 삭제
  acsDelManagersIpSec ({commit, state}, payload) {
    this.$axios.$delete(`${ApiUrl.managersIpSecUrl}?admin_id=${payload.admin_id}&ip=${payload.ip}`)
      .then((res) => {
        if (res.code === 'ok') {
          commit('mutDelManagersIpSecResult', res.result)
        } else {
          commit('mutationErrorMessage', res.result.msg)
        }
      })
      .catch((err) => {
        commit('mutationErrorMessage', err)
      })
  },
  // 메뉴 정보
  acsMenuTree ({commit, state}, id) {
    const result = {}
    result.id = id
    this.$axios.$get(`${ApiUrl.managersMenuUrl}/${id}`)
      .then((res) => {
        result.result = res.result
        commit('mutationMenuTree', result)
      })
      .catch((error) => {
        commit('mutationErrorMessage', error)
      })
  },
  async acsPostManagersMenu ({commit, state}, payload) {
    try {
      const res = await this.$axios.$post(`${ApiUrl.managersMenuUrl}/${payload.admin_id}`, payload.menu)
      if (res.code === 'ok') {
        commit('postManagerMenuResult', res)
      } else {
        commit('mutationErrorMessage', res.result.msg)
      }
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
  },
  // 관리자 그룹 추가
  async acsPostMmanagersgroup ({commit, state}, payload) {
    try {
      const res = await this.$axios.$post(ApiUrl.managersGroupUrl, payload, {loading: false})
      if (res.code !== 'ok') {
        return {code: 'nok', errors: res.result.msg}
      }
      commit('mutPostMmanagersgroup', res)
      return res
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 관리자 그룹 삭제
  async acsDelManagersGroup ({commit, state}, payload) {
    try {
      const res = await this.$axios.$delete(`${ApiUrl.managersGroupUrl}/${payload.admin_id}/${payload.admin_type}`)
      if (res.code === 'ok') {
        commit('mutPostMmanagersgroup', res)
      } else {
        commit('mutationErrorMessage', res.result.msg)
      }
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
  },
  // 단일 관리자 그룹 이동
  async acsPutManagers ({commit, state}, payload) {
    try {
      // 문서와 다름 문서: put 으로 되어 있습 소스: post
      // #31114 - [System] 관리자 설정 > 관리자/그룹편집 > 체크인/아웃(적용/취소)시 로딩바 및 경고창이 많이 나타남
      const res = await this.$axios.$post(`${ApiUrl.managersGroupUrl}/${payload.fromAdminId}/${payload.toAdminId}`, null, {loading: false, successAlert: false})
      if (res.code !== 'ok') {
        commit('mutationErrorMessage', res.result.msg)
        return false
      }
      commit('mutationPutManagers', res)
      return 'ok'
    } catch (e) {
      commit('mutationErrorMessage', e)
    }
  },
  // 단일 관리자 로케일 수정
  async acsPutManagersLocale ({commit, state}, payload) {
    try {
      const {code, result} = await this.$axios.$put(`${ApiUrl.managersGroupUrl}/${payload.admin_id}/${payload.locale_type}`)
      if (code === 'ok') {
        commit('mutationPutManagersLocale', result)
      } else {
        commit('mutationErrorMessage', result.msg)
      }
    } catch (err) {
      commit('mutationErrorMessage', err)
    }
  },
  // 관리자/그룹 - 상세정보
  async acsManagersGroup ({commit, state}, adminId) {
    try {
      const data = await this.$axios.$get(`${ApiUrl.managersGroupUrl}/${adminId}`)
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('acsManagersGroup', data.result)
      const deviceData = {}
      const treeData = {}
      const ipData = {}
      deviceData.data = data.result.parent_admin_device
      commit('mutDeviceTree', deviceData)
      treeData.result = (data.result.parent_admin_id === null) ? data.result.admin_menu : data.result.parent_admin_menu
      commit('mutationMenuTree', treeData)
      ipData.result = (data.result.parent_admin_ip === null) ? data.result.admin_ip : data.result.parent_admin_ip
      commit('acsManagersIp', ipData)
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 관리자/그룹 - 상세정보 unload
  async acsManagersGroupUnload ({commit, state}, adminId) {
    try {
      const data = await this.$axios.$get(`${ApiUrl.managersGroupUrl}/${adminId}`, {loading: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('acsManagersGroup', data.result)
      const deviceData = {}
      const treeData = {}
      const ipData = {}
      deviceData.data = data.result.parent_admin_device
      commit('mutDeviceTree', deviceData)
      treeData.result = (data.result.parent_admin_id === null) ? data.result.admin_menu : data.result.parent_admin_menu
      commit('mutationMenuTree', treeData)
      ipData.result = (data.result.parent_admin_ip === null) ? data.result.admin_ip : data.result.parent_admin_ip
      commit('acsManagersIp', ipData)
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 관리자 설정 적용
  async acsPostManagersDetail ({commit, state}, payload) {
    const success = {}
    success.error = null
    try {
      const options = {
        headers: {
          'Content-type': 'multipart/form-data'
        }
      }
      const {code, result} = await this.$axios.$post(`${ApiUrl.managersDetailUrl}/${payload.admin_id}`, jsonToFromData(payload.detail), options)
      if (code !== 'ok') {
        commit('mutationErrorMessage', result.msg)
      } else {
        commit('mutationManagerDetailResult', result.msg)
      }
    } catch (e) {
      commit('mutationErrorMessage', e)
    }
  },
  // 단일 관리자 계정 보안설정 managersSecurityUrl
  async acsPostmanagersSecurity ({commit, state}, payload) {
    const success = {}
    success.error = null
    try {
      const {code, result} = await this.$axios.$post(`${ApiUrl.managersSecurityUrl}/${payload.admin_id}`, payload.security)
      if (code === 'ok') {
        success.code = code
        success.result = result
        commit('mutationPostmanagersSecurityResult', success)
      } else {
        commit('mutationErrorMessage', result.msg)
      }
    } catch (e) {
      commit('mutationErrorMessage', e)
    }
  },
  // 단일 관리자 비밀번호 변경
  async acsPostManagersPwd ({commit, state}, payload) {
    try {
      const data = await this.$axios.$post(`${ApiUrl.managersPwdUrl}/${payload.admin_id}`, payload.password, {successAlert: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('mutationPostManagersPwd', data)
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 이미지 가져오기
  async acsGetManagersImg ({commit, state}, adminId) {
    const result = {}
    result.error = null
    try {
      const data = await this.$axios.$get(`${ApiUrl.managersImgUrl}/${adminId}`)
      if (data.code !== 'ok') {
        return false
      }
      commit('mutationGetManagersImg', data.result)
      return 'ok'
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
  },
  async acsCidrToIplist ({commit, state}, ipAddress) {
    let result = {}
    result.error = null
    try {
      const ip = this.$axios.$get(`${ApiUrl.cidrToIplistUrl}?cidr=${ipAddress}`)
      if (ip.ret === 'ok') {
        result = ip
        commit('acsCidrToIplist', result)
      } else {
        commit('mutationErrorMessage', result.msg)
      }
    } catch (e) {
      commit('mutationErrorMessage', e)
    }
  },
  acsAdminIpCurrConcat ({commit, state}, payload) {
    commit('mutaionAdminIpCurrConcat', payload)
  },
  // 공통설정 값 가져오기 (2021-07-28) 현재 사용안하는 것으로 보임
  async acsGetAdminGeneral ({commit}) {
    try {
      const data = await this.$axios.$get(ApiUrl.generalSettUrl)
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      const result = {
        admin_valid_term: data.result['system.admin.account_expire_term'],
        admin_pw_expire_term: data.result['system.admin.password_expire_term']
      }
      commit('acsGetAdminGeneral', result)
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  acsSetErrorMessage ({commit, state}, payload) {
    commit('mutationErrorMessage', payload)
  },
  async acsManagersIpInhrit ({commit, state}, payload) {
    try {
      const res = await this.$axios.$put(`${ApiUrl.managersIpInhritUrl}/${payload.admin_id}`, payload.params, {loading: true, successAlert: false})
      if (res.code === 'ok') {
        return res
      } else {
        commit('mutationErrorMessage', res.result.msg)
      }
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
  },
  async acsManagersIpAdd ({commit, state}, payload) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$post(`${ApiUrl.managersIpAddUrl}/${payload.admin_id}`, payload.params, {loading: true, successAlert: false})
      if (res.code !== 'ok') {
        commit('mutationErrorMessage', res.result.msg)
      }
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
      res.code = 'nok'
      res.result.msg = error.message
      return res
    }
  },
  async acsManagersIpDel ({commit, state}, payload) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$delete(`${ApiUrl.managersIpDelUrl}/${payload.admin_ip_id}`, {loading: true, successAlert: false})
      if (res.code !== 'ok') {
        commit('mutationErrorMessage', res.result.msg)
      }
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
      res.code = 'nok'
      res.result.msg = error.message
      return res
    }
  },
  async acsAdminManagersAllId ({commit, state}, payload) {
    let muteParam = true
    if (payload.loadingMute) {
      muteParam = false
    }
    let photo = false
    if (payload.photo) {
      photo = true
    }
    try {
      const options = {
        headers: {
          'Content-type': 'multipart/form-data'
        },
        successAlert: false,
        loading: muteParam
      }
      const data = await this.$axios.$post(`${ApiUrl.managersAllUrl}/${payload.admin_id}`, jsonToFromData(payload.params), options)
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      if (photo) {
        commit('mutPostMmanagersgroup', data)
      }
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async commitAndRollBackPage ({commit, state}, type) {
    let muteParam = true
    if (typeof (type) === 'object') {
      muteParam = false
      type = type.type
    }
    try {
      let msg = {}
      if (type === 'apply') {
        msg = {loading: muteParam, applyMsg: true}
      } else if (type === 'cancel') {
        msg = {loading: muteParam, cancelMsg: true}
      }
      const data = await this.$axios.$put(`${ApiUrl.url}/${type}`, void 0, msg)
      if (data.code !== 'ok') {
        return false
      }
      this.dispatch(`common/common/setIsChanged`, false)
      return 'ok'
    } catch (error) {
      return error
    }
  },
  // #31114 - [System] 관리자 설정 > 관리자/그룹편집 > 체크인/아웃(적용/취소)시 로딩바 및 경고창이 많이 나타남
  async adminGroupCommit ({commit, state}, type) {
    try {
      let msg = {}
      if (type === 'apply') {
        msg = {loading: false, applyMsg: false, successAlert: false}
      } else if (type === 'cancel') {
        msg = {loading: false, cancelMsg: false, successAlert: false}
      }
      const data = await this.$axios.$put(`${ApiUrl.url}/${type}`, void 0, msg)
      if (data.code !== 'ok') {
        return false
      }
      this.dispatch(`common/common/setIsChanged`, false)
      return 'ok'
    } catch (error) {
      return error
    }
  },
  async adminExternalCommit ({commit, state}, type) {
    try {
      let msg = {}
      if (type === 'apply') {
        msg = {loading: true, applyMsg: false, successAlert: false}
      } else if (type === 'cancel') {
        msg = {loading: true, cancelMsg: false, successAlert: false}
      }
      const data = await this.$axios.$put(`${ApiUrl.externalAuthUrl}/${type}`, void 0, msg)
      if (data.code !== 'ok') {
        return data.result.msg
      }
      this.dispatch(`common/common/setIsChanged`, false)
      return 'ok'
    } catch (error) {
      return error
    }
  },
  // #31114 - [System] 관리자 설정 > 관리자/그룹편집 > 체크인/아웃(적용/취소)시 로딩바 및 경고창이 많이 나타남
  // 관리자/그룹 - 상세정보
  async getManagersGroup ({commit, state}, adminId) {
    try {
      const data = await this.$axios.$get(`${ApiUrl.managersGroupUrl}/${adminId}`, {loading: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('acsManagersGroup', data.result)
      const deviceData = {}
      const treeData = {}
      const ipData = {}
      deviceData.data = data.result.parent_admin_device
      commit('mutDeviceTree', deviceData)
      treeData.result = (data.result.parent_admin_id === null) ? data.result.admin_menu : data.result.parent_admin_menu
      commit('mutationMenuTree', treeData)
      ipData.result = (data.result.parent_admin_ip === null) ? data.result.admin_ip : data.result.parent_admin_ip
      commit('acsManagersIp', ipData)
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async finalCommand ({state}, type) { // error 발생시 error 메세지 리턴기능이 누락됨. 어디에서 사용하는지 전부 파악할 수 없음으로, 하단에 별도로 구현함(commitAndRollBackDeviceGroup)
    const axiosConfig = (type === 'apply') ? { applyMsg: true } : { cancelMsg: true }
    const {code} = await this.$axios.$get(`${ApiUrl.devicesUrl}/${type}`, axiosConfig)
    if (code === 'ok') {
      return true
    }
    return false
  },
  async commitAndRollBackDeviceGroup ({commit, state}, type) {
    // 별도로 commit 하는 정책으로 유지
    try {
      let config = {}
      if (type === 'apply') {
        config = {loading: false, applyMsg: false}
      } else if (type === 'cancel') {
        config = {loading: false, cancelMsg: false}
      }
      const url = '/api/sm/admin-device-group'
      const data = await this.$axios.$put(`${url}/${type}`, {}, config)
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },

  async generateExternalAuthKey ({ commit }, { adminId }) {
    try {
      const res = await this.$axios.$post(`/api/au/external-auth/${adminId}`, void 0, {loading: false, successAlert: false})
      if (res.code === 'ok') {
        commit('updateExternalAuthKey', res.result.api_token)
      }
      return res
    } catch (error) {
      return { code: 'error', errors: error }
    }
  },
  async getAdminOtpMenu ({ commit }, { adminId }) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$get(`${apiPrefix}/managers/otp/${adminId}`)
      if (res.code === 'ok') {
        commit('setAdminOtpMenu', res.result)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async updateAdminOtpMenu ({ commit }, { adminId, otpMenu }) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const params = {
        admin_otp_menu_item: _.map(otpMenu, menu => ({
          admin_otp_menu_id: menu.admin_otp_menu_id,
          admin_otp_menu_enable_yn: menu.admin_otp_menu_enable_yn === true ? 1 : 0
        }))
      }
      res = await this.$axios.$put(`${apiPrefix}/managers/otp/${adminId}`, params)
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  }
}

export const getters = {}
export const strict = false
